import { useParams } from '@tanstack/react-router';
import { useUserQuery } from '@anytag/graphql';
import { RenderDataWithFallback } from '@anytag/shared-atoms';
import { useQueryHelper, useUpdateDocumentTitle } from '@anytag/shared-hooks';
import { Header } from '@anytag/shared-molecules';
import { UserForm, getUserFormValues } from '@anytag/shared-organisms';
import { useUpdateUser } from './hooks';

export interface UserDetailsProps {
  isUserSettingsForAdvertisers?: boolean;
}
export const UserDetails = ({ isUserSettingsForAdvertisers }: UserDetailsProps | undefined = {}) => {
  const { t, navigate, enqueueSnackbar } = useQueryHelper();
  const params = useParams({ strict: false }); // can be /user-settings (for Advertiser) or /user/$id

  useUpdateDocumentTitle({
    title: 'documentTitle.EditUser',
    appHeader: 'appHeader.Edit User',
    href: isUserSettingsForAdvertisers ? undefined : '/user',
    alwaysBackToParent: true
  });

  const { updateUser, userId } = useUpdateUser({ isUserSettingsForAdvertisers });
  const { data, loading } = useUserQuery({
    variables: { pk: isUserSettingsForAdvertisers ? Number(userId) : Number(params.id) },
    fetchPolicy: 'network-only',
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
      navigate({ to: '/user' });
    }
  });

  const userData = data?.user;

  return (
    <RenderDataWithFallback loading={loading}>
      <div>
        <Header />

        <UserForm
          onSubmit={updateUser(userData?.role)}
          isUserSettingsForAdvertisers={isUserSettingsForAdvertisers}
          defaultValues={getUserFormValues(userData, 'edit')}
        />
      </div>
    </RenderDataWithFallback>
  );
};
